import { useContext } from 'react';
import {
    Header as StyledHeader,
    Title,
    Subtitle,
    ContentRight
} from './Header.styles';
import { SwegonLogo } from '@swegon-core/uic/dist/src/theme';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';

export interface HeaderProps {
    subtitle?: string;
    children?: React.ReactNode;
}

export const Header = (props: HeaderProps) => {
    const { subtitle, children } = props;
    const { l } = useContext(TranslationContext);
    const title = l('ahuDesignLite.applicationName');

    return (
        <StyledHeader>
            <SwegonLogo />
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            <ContentRight>{children}</ContentRight>
        </StyledHeader>
    );
};
